// libs
import React, { useState } from 'react';

// components
import NewCardForm from "./NewCardForm";

const NewCard = (props) => {
    const { subAccount: {subAccountCode, subAccountType:{ code } }} = props;

    return (
        <div className="cardmanager">
            <NewCardForm
                closeModal={props.closeModal}
				newCardSuccessModal={props.newCardSuccessModal}
                subAccountType={ code }
				subAccountCode={ subAccountCode }
            />
        </div>
    );
};

export default NewCard;
